import React from 'react';
import { Button } from '../components/ui';

interface DesktopFooterProps {
  onInfo: () => void;
}

const DesktopFooter: React.FC<DesktopFooterProps> = ({ onInfo }) => {
  return (
    <div className="hidden md:block text-center py-4 text-gray-400">
      <Button
        onClick={onInfo}
        variant="text"
        size="small"
        className="normal-case text-sm"
      >
        What is Ground Rounds?
      </Button>
    </div>
  );
};

export default DesktopFooter;

